/**
 * First unsettled hydrate: seed known board ids, then return socket-held pending
 * ids that must still ring (even when already in the list — mid-fetch creates).
 */
export function seedKnownCreatedOrderIds(
  listIds: string[],
  pendingIds: Iterable<string>,
): { known: Set<string>; toAnnounce: string[] } {
  const known = new Set(listIds);
  const toAnnounce: string[] = [];
  for (const id of pendingIds) {
    if (!id) continue;
    // Drop from seed so announceCreatedOrder treats it as new and rings.
    known.delete(id);
    toAnnounce.push(id);
  }
  return { known, toAnnounce };
}
